import _filter from 'lodash/filter';
import _get from 'lodash/get';
import _map from 'lodash/map';
import * as actions from '../redux/constants';
import * as lmsService from '../core/lms';
import gradeService from '../core/gradebook/grades';
import { updateSearchParamsInBrowser } from '../utils/util';

export {
  getGradebook,
  getGradebookInstructor,
  formatGradebook,
} from './getGradebook';
export { getStudentGradeObj } from './student-grade-obj';
export { toggleShowFilterOptionsGradebook } from './filter';
export { applyGradebookFilters } from './applyGradebookFilters';
export {
  updateGradebook,
  updateAlert,
  updateInstructor,
  updateStudent,
  updateSearchType,
  updateSearchTypeMenu,
  setVisibleFilterSection,
  overrideGrade,
} from './updateGradebook';
export { updateAllAverages, updateAssignmentAverages } from './averages';
export * from './individualStudentGradebook';

export const setGradebookSearchPhrase = (searchPhrase) => (dispatch) => {
  dispatch({
    type: actions.SET_GRADEBOOK_SEARCH_PHRASE,
    payload: { searchPhrase },
  });
};

export const setGradebookExceptionGroups = (exceptionGroups) => (dispatch) => {
  dispatch({
    type: actions.SET_GRADEBOOK_EXCEPTION_GROUPS,
    payload: { exceptionGroups },
  });
};

export const setGradebookFilterTypes = (filterTypes) => (dispatch) => {
  dispatch({
    type: actions.SET_GRADEBOOK_FILTER_TYPES,
    payload: { filterTypes },
  });
};

export const setGradebookV2Active = (isActive) => (dispatch) => {
  dispatch({
    type: actions.SET_GRADEBOOK_V2_ACTIVE,
    payload: isActive,
  });
};

export const resetGradebook = () => (dispatch) => {
  dispatch({ type: actions.RESET_GRADEBOOK });
};

// TODO: No dispatch for this, think its only used for load testing
export const batchSaveGrades =
  ({ studentIds, grade, courseId, assignmentId }) =>
  async () => {
    const grades = _map(studentIds, (id) => ({
      user_id: id,
      course_id: courseId,
      assignment_id: assignmentId,
      grade,
    }));
    await gradeService.batchSaveGrades({ courseId, grades });
  };

export const selectIndividualStudentGradebook = (studentId) => (dispatch) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('studentId', studentId);
  updateSearchParamsInBrowser(searchParams);
  dispatch({
    type: actions.SELECT_INDIVIDUAL_STUDENT_GRADEBOOK,
    payload: { studentId },
  });
};

export const toggleCategoryExpandCollapse = (categoryId) => (dispatch) => {
  dispatch({
    type: actions.TOGGLE_CATEGORY_EXPAND_COLLAPSE,
    payload: { categoryId },
  });
};

export const togglePerformanceOverviewCollapse = (isOpen) => (dispatch) => {
  dispatch({
    type: actions.TOGGLE_PERFORMANCE_OVERVIEW_COLLAPSE,
    payload: { isOpen },
  });
};

export const updateShowPercentageCourseSettings =
  (courseId, showPercentage) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.GRADEBOOK_SETTINGS_UPDATING,
        payload: true,
      });
      const {
        gradebook: { settings },
      } = getState();
      let newSettings = _filter(
        settings,
        (currentSetting) => currentSetting.key !== 'showPercent',
      );
      newSettings.push({
        key: 'showPercent',
        value: showPercentage,
        __altered: true,
      });

      const updatedSetting = await lmsService.updateGradebookSettings(
        courseId,
        newSettings,
      );
      newSettings = newSettings.map((item) =>
        item.key === 'showPercent'
          ? _get(updatedSetting, 'settings[0][0]', item)
          : item,
      );
      dispatch({
        type: actions.GET_GRADEBOOK_SETTINGS_SUCCESS,
        payload: { settings: newSettings },
      });

      dispatch({
        type: actions.GRADEBOOK_SETTINGS_UPDATING,
        payload: false,
      });
    } catch (err) {
      dispatch({
        type: actions.APP_LOADING,
        payload: false,
      });
      throw err;
    }
  };
